import { Tooltip } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { ACTION_BTN_HOVER_CLR, SERVER_URL } from "@/Constants/common";
import { TOOLTIPTEXT, toastMessageText } from "@/utilities/CommonText";
import { showSuccessToast, showCommonToast } from "@/utilities/utils";

import { serviceRouteConstants } from "../../../../Constants/routingConstants";
import { toggleEditBankCandidateComplianceModal } from "../../../../reducers/clientcandidatedetail";
import { apiEncrypt } from "../../../../utilities/keyEncryption";
import ActionIcons from "../ActionIcons";

/**
 * This is a functional component that returns a JSX element for ComplianceAction.
 *
 * @return {JSX.Element} JSX element representing ComplianceAction
 */
const ComplianceAction = () => {
  const { candidateDetails, selectedDocuments, candidateDocuments } =
    useSelector((state) => state.clientCandidateDetail);
  const { isPremiumAccount, clientUserAllPermissions, session } = useSelector(
    (state) => state.session,
  );
  const { client_allow_e_compliance } = session;
  const { user } = useSelector((state) => state.clientProfile);

  const [editLoading, seteditLoading] = useState(false);

  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();

  let myInterval;
  /**
   * Check if the document has focus and perform certain actions if it doesn't.
   */
  // const checkDocumentFocus = () => {
  //   if (!document.hasFocus()) {
  //     clearInterval(myInterval);
  //     setDownloadLoading(false);
  //     showSuccessToast(toastMessageText.documentDownloaded);
  //     clearInterval(myInterval);
  //   }
  // };
  /**
   * A function that shows a download message, initiates a success toast, and sets an interval to check document focus.
   */
  const ShowDownloadMessage = () => {
    showSuccessToast(toastMessageText.downloading);
    // myInterval = setInterval(checkDocumentFocus, 1000);
  };

  const getLink = () => {
    let link = "#";
    if (selectedDocuments.length == 0) {
      return link;
    }
    if (checkSelectedDocumentIncludedNotUploaded()) {
      // showErrorToast(toastMessageText.selectDocumentToDownload, {
      //   id: "not-uploaded-document-selected",
      // });
      return link; // Prevent redirection
    }
    link = `${SERVER_URL}${serviceRouteConstants.exportCompliance}?user_id=${apiEncrypt(session.user_id)}&type=${apiEncrypt(session.user_type)}&login_user_token=${session.user_token}&document_id=${selectedDocuments.join(",")}&candidate_id=${candidateDetails.candidate_id}&url=${window.location.href}`;
    return link;
  };

  // check selected document inclued any not uploaded dowloaded so not show error
  const checkSelectedDocumentIncludedNotUploaded = () => {
    for (const category in candidateDocuments) {
      if (candidateDocuments.hasOwnProperty(category)) {
        const documents = candidateDocuments[category];
        const hasNotUploaded = documents.some(
          (doc) =>
            selectedDocuments.includes(doc.document_id) &&
            doc.status_title === "Not Uploaded",
        );
        if (hasNotUploaded) {
          return true;
        }
      }
    }
    return false;
  };

  return (
    <div className="ComplianceAction_Wrapper">
      <div className="flex h-[40px] cursor-pointer overflow-hidden rounded-lg bg-grey [&>*:last-child]:border-r-0 [&>*]:grid [&>*]:min-w-[56px] [&>*]:place-items-center [&>*]:border-0 [&>*]:border-r [&>*]:border-r-[#E5E6E9] [&>*]:text-txtColor">
        {/* {
          !clientUserAllPermissions ||
            clientUserAllPermissions.is_allow_to_view_download_compliance === 1 ? (
            <>
              <Tooltip title={TOOLTIPTEXT.bulkDownload}>
                <a
                  className={`${client_allow_e_compliance ? "cursor-pointer" : "opacity-30 hover:opacity-30 hover:text-grey cursor-not-allowed"} transition-linear group inline-block ${downloadLoading ? "pointer-events-none" : ""} ${!client_allow_e_compliance ? "cursor-not-allowed opacity-40 hover:opacity-40" : ACTION_BTN_HOVER_CLR.lightBlue}`}
                  href={getLink()}
                  onClick={(e) => {
                    if (!isPremiumAccount && !client_allow_e_compliance) {
                      e.preventDefault();
                      dispatch(toggleOurServiceModal(true));
                      return;
                    }
                    if (!client_allow_e_compliance) {
                      showRoleAccessToast();
                      e.preventDefault();
                      return;
                    }
                    if (checkSelectedDocumentIncludedNotUploaded()) {
                      // console.log("Document not uploaded error triggered.");
                      showCommonToast(toastMessageText.compliacneNotUploadedDownload, {
                        id: "app-locum-candidates-selected",
                      });
                      e.preventDefault();
                      return;
                    }
                    if (selectedDocuments.length == 0) {
                      e.preventDefault();
                      showErrorToast(toastMessageText.selectDocumentToDownload, {
                        id: "no-document-selected-download",
                      });
                      return;
                    }
                    // if (selectedDocuments.length > 10) {
                    //   e.preventDefault();
                    //   showErrorToast(toastMessageText.maxDocumentDownload, {
                    //     id: "max-documents-selected",
                    //   });
                    //   return;
                    // }
                    if (client_allow_e_compliance) {
                      if (selectedDocuments.length == 1) {
                        ShowDownloadMessage();
                        // sho
                      }
                      else {
                        // e.preventDefault();
                        showSuccessToast(toastMessageText.downloadDocumentInDownloadSection);
                        localStorage.setItem("downloadedDocument", "true");
                      }
                    }
                    // setDownloadLoading(true);
                    // ShowDownloadMessage();
                  }}
                  target="_self"
                >
                  {client_allow_e_compliance ? (
                    <ActionIcons isLoading={downloadLoading} type={"download"} />
                  ) : (
                    <DownloadIcon cls="text-txtColor" />
                  )}
                </a>
              </Tooltip>
            </>
          ) : null} */}

        {isPremiumAccount &&
        clientUserAllPermissions?.is_allow_to_upload_candidate_compliance !==
          0 ? (
          !user.is_bank_client && candidateDetails?.is_bank_candidate ? (
            <Tooltip title={TOOLTIPTEXT.edit}>
              <div
                className={`group ${ACTION_BTN_HOVER_CLR.lightBlue}`}
                onClick={() => {
                  if (selectedDocuments.length === 1) {
                    dispatch(toggleEditBankCandidateComplianceModal(true));
                  } else {
                    showCommonToast("Please select one compliance ", {
                      id: "no-user-selected",
                    });
                  }
                }}
              >
                <ActionIcons isLoading={editLoading} type={"edit"} />
              </div>
            </Tooltip>
          ) : null
        ) : null}
      </div>
    </div>
  );
};

export default ComplianceAction;
